import { request } from '@akerolabs/akero-vue/src/utils/request'

/**
 * Interface to the Integrations API

 * @param {function} urlFactory
 * @returns {{request(): Promise<void>}}
 */
export default (urlFactory) => {
  /**
   * Return the base URL for the Integrations API
   * @returns {*}
   */
  const getURL = () => urlFactory()

  /**
   * Return the set of headers required by the Integrations API
   * @returns {*}
   */
  const getHeaders = () => {
    // todo: rework that request wrapper in vue-core to decouple client provided configuration from provider (axios) allowing both to be reusable in different contexts
    const dict = request.defaults.headers
    return ['Authorization', 'x-active-account'].reduce(
      (obj, header) =>
        (dict[header] && {
          ...obj,
          [header]: dict[header],
        }) ||
        obj,
      { 'Content-Type': 'application/json' },
    )
  }

  /**
   * Return a set of base options for fetch
   * @returns {*}
   */
  const getOptions = () => ({})

  return {
    /**
     * Generic request
     * @param {String} endpoint
     * @param {Object=} opts
     * @param {Object=} headers
     * @returns {Promise<*>}
     */
    async request(endpoint, opts = {}, headers = {}) {
      if (!endpoint) return
      const url = `${getURL()}${endpoint}`
      const options = {
        ...opts,
        ...getOptions(),
        headers: { ...headers, ...getHeaders() },
      }
      return fetch(url, options)
    },
  }
}
